module.exports = __webpack_public_path__ + "img/WXbarcode11.905f36d6.png";